




























































































import { TypeRapport } from "../shared/Rapport";
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import DttConfig from "./dttConfig.vue";
import MobileMixin from "@/mixins/mobileMixin";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {
    DttConfig,
  },
})
export default class RapportSelection extends mixins(MobileMixin, ErrorMixin) {
  public listeRapports: any = new Map();
  public typePan: string = "";
  public typesRapports: string[] = new Array();
  public searchTxt: string = "";
  public typeSelected = "";
  public descriptions = new Array();
  public showDtt: boolean = false;
  public mapTypes = new Map();
  public dialogPdf: boolean = false;
  public onMobile: boolean = this.isMobile();

  @Prop({ default: "rapport" }) public type!: string;
  @Prop() public rapport!: TypeRapport;

  /**
   * methode de filtra des rapport
   */
  public searchRapportFilter() {
    let mesRapports: TypeRapport[] = new Array();
    if (this.listeRapports !== undefined && this.listeRapports.length === 0) {
      return;
    } else {
      const selectedPan =
        typeof this.typePan === "string"
          ? this.typePan
          : this.mapTypes.get(this.typePan);
      // console.log(selectedPan, this.typePan);
      if (this.searchTxt.trim() !== "") {
        const allrep: [string, TypeRapport[]][] = Object.entries(
          this.listeRapports
        );
        for (const [key, value] of allrep) {
          const raps = value.filter((rap: any) => {
            if (
              rap &&
              rap.localisedTitle
                .toUpperCase()
                .includes(this.searchTxt.toUpperCase()) &&
              rap.famille !== "HIDDEN" &&
              rap.localisedTitle !== "OPERATIONNEL.REMBOURSEMENTS_BK"
            ) {
              return true;
            } else {
              return false;
            }
          });
          mesRapports = mesRapports.concat(raps);
        }
      } else {
        // console.log(this.listeRapports[selectedPan])
        // console.log(selectedPan);
        if (selectedPan !== "") {
          mesRapports = this.listeRapports[selectedPan].filter((rap: any) => {
            // console.log(rap.localisedTitle);
            return rap && !rap.localisedTitle.includes("REMBOURSEMENTS_BK");
          });
        } else {
          mesRapports = this.listeRapports[selectedPan];
        }
      }
    }
    return mesRapports;
  }

  /**
   * verification q'un rapport est selectionné
   */
  public isSelectedRapport(rapport: TypeRapport) {
    return (
      this.monrapport.className !== "" &&
      rapport.className === this.monrapport.className
    );
  }

  /**
   * generation d'un rapport
   */
  public selectRapport(rapport: TypeRapport) {
    console.log(rapport);
    this.$store
      .dispatch("rapport/checkRapportType", rapport.className)
      .then((result: any) => {
        if (result.SAVE_FILTERS !== undefined) {
          this.$emit("saveFilters", result.SAVE_FILTERS);
        }
        if (result.CAN_SAVE_FILTERS !== undefined) {
          this.$emit("canSaveFilters", result.CAN_SAVE_FILTERS);
        }
        if (result.TRIS !== undefined) {
          this.$emit("tris", result.TRIS);
        }
        this.$emit("typeRapport", result);
        if (!result.PDF_AVAILABLE && this.onMobile) {
          this.notAPdf();
        } else {
          this.$emit("rapportSelected", rapport);
          // this.store
          if (result.DESCRIPTIONS !== undefined) {
            this.descriptions = result.DESCRIPTIONS;
            this.showDtt = true;
            // console.log("dtt ok");
          } else {
            this.monrapport.dttConfig = undefined;
          }
        }
      });
  }

  /**
   * affichage d'un message d'erreur si tentative de telecharger un rapport non pdf sur un mobile
   */
  public notAPdf() {
    this.dialogPdf = true;
  }

  /**
   * validation du dialogue de configuration du rapport dtt
   */
  public hide(config: any) {
    this.showDtt = false;
    this.monrapport.dttConfig = config;
    this.$emit("rapportSelected", this.monrapport);
  }

  public mounted() {
    // console.log(this.monrapport);
    this.$store
      .dispatch("rapport/getAllReports")
      .then((rapports) => {
        this.listeRapports = rapports;
        const cache = new Array();
        Object.entries(rapports).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            this.typesRapports.push(key);
            let counter = 0;
            value.forEach((rap: any) => {
              if (!cache.includes(rap.className + rap.famille)) {
                cache.push(rap.className + rap.famille);
              } else {
                this.listeRapports[key][counter] = undefined;
              }
              counter += 1;
            });
          }
        });
        if (this.typesRapports.includes("HIDDEN")) {
          this.typesRapports.splice(this.typesRapports.indexOf("HIDDEN"), 1);
        }
        this.mapTypes = new Map();
        this.typesRapports.forEach((type, index) => {
          this.mapTypes.set(index, type);
        });

        // Auto-sélection SEULEMENT si c'est la première fois (pas de période définie)
        this.$nextTick(() => {
          this.autoSelectRapportIfNeeded();
        });
      })
      .catch((error: any) => {
        this.$store.dispatch("login/loading", false);
        this.setErrorFromTxt(this.$t("ErrorGettingAllReport").toString());
      });
  }

  private autoSelectRapportIfNeeded() {
    console.log(
      "autoSelectRapportIfNeeded - className:",
      this.monrapport.className
    );

    if (this.monrapport.className !== "") {
      console.log("Déclenchement du clic automatique");
      setTimeout(() => {
        const selectedElement = document.querySelector(".rselected");
        if (selectedElement) {
          (selectedElement as HTMLElement).click();
        }
      }, 100);
    }
  }

  get client(): string {
    const cli = this.$store.getters["getClient"];
    return cli;
  }

  get monrapport() {
    return this.rapport;
  }
}
